@if (news$ | async; as news) {
  <dcr-dialog [open]="news.items.length > 0" type="confirm" confirm-label="Sluiten" (confirm)="onDialogConfirm(news.items)">
    @if (news.items.length > 0) {
      <dcr-carousel>
        @for (item of news.items; track item) {
          <dcr-carousel-item>
            <dcr-image slot="header" [src]="item.image | assetsPath: 'images' : 'news'" [alt]="item.title" fit="cover"></dcr-image>
            <div slot="content" class="[ w-full ]">
              <dcr-card class="w-full" [headline]="item.title" [subhead]="item.publishDate | date: 'dd/MM/yy HH:mm'" slot="content">
                <div slot="content" class="[ p-m ]">
                  <campus-froala-viewer slot="content" [content]="item.description | mathjax"></campus-froala-viewer>
                </div>
              </dcr-card>
            </div>
          </dcr-carousel-item>
        }
      </dcr-carousel>
    }
  </dcr-dialog>
}
